export const cdCompletePercentageOptions = [
  { label: "0%", value: 0 },
  { label: "15%", value: 15 },
  { label: "30%", value: 30 },
  { label: "60%", value: 60 },
  { label: "90%", value: 90 },
  { label: "100%", value: 100 },
];
